export default __webpack_public_path__ + "static/media/NI.f4504d14.svg";